import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/lib/auth";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Quiz from "@/pages/Quiz";
import Dashboard from "@/pages/Dashboard";
import Pricing from "@/pages/Pricing";
import HustleDetail from "@/pages/HustleDetail";
import PaymentSuccess from "@/pages/PaymentSuccess";
import GigsPublic from "@/pages/GigsPublic";
import PublicProfile from "@/pages/PublicProfile";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/gigs" element={<GigsPublic />} />
            <Route path="/quiz" element={<Quiz />} />
            <Route path="/app" element={<Dashboard />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/hustle/:id" element={<HustleDetail />} />
            <Route path="/u/:handle" element={<PublicProfile />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
          </Routes>
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
